







import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { UGCsApi } from "@/services/api-service";

@Component
export default class UGCViewer extends Vue {
  @Prop()
  private ugcUuid?: string;

  private ugcUrl: string | null = null;

  private created() {
    if (!this.ugcUuid) {
      return;
    }
    this.getUgc(this.ugcUuid);
  }

  @Watch("ugcUuid")
  private async getUgc(uuid: string) {
    const ugcRes = await UGCsApi.instance.getUGC(uuid);
    if (!ugcRes?.data?.data?.ugc) {
      return;
    }
    this.ugcUrl = ugcRes.data.data.ugc.thumbnailUrl
      ? ugcRes.data.data.ugc.thumbnailUrl
      : (ugcRes.data.data.ugc.url as string);
  }
}
